<template>
  <span>
    <span
      :id="`document-issue-mark-${_uid}`"
      class="document-issue-mark"
      :style="{
        backgroundColor: color,
      }"
    ></span>

    <b-popover triggers="hover" placement="top" :target="`document-issue-mark-${_uid}`">
      {{ label }}
    </b-popover>
  </span>
</template>

<script>
const labels = {
  absent: "Цвет отсутствующего документа",
  expired: "Цвет истекшего срока годности",
  expiring: "Цвет истекающего срока годности",
};

export default {
  props: ["issue", "color"],
  computed: {
    label() {
      return labels[this.issue];
    },
  },
};
</script>

<style lang="scss">
.document-issue-mark {
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
</style>
